module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v1-980.fbc22806.png";